export const groupBy = (items, key) =>
  items.reduce(
    (result, item) => ({
      ...result,
      [item[key]]: [...(result[item[key]] || []), item],
    }),
    {}
  );

export const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};
